module.exports = ":host {\n    display: inline-block;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/back-button/back-button.component.css
// module id = ./src/app/shared/back-button/back-button.component.css
// module chunks = main